import { render } from "./CZHistoricConsumptionCo2Water.vue?vue&type=template&id=0c5bcee6&scoped=true&ts=true"
import script from "./CZHistoricConsumptionCo2Water.vue?vue&type=script&lang=ts"
export * from "./CZHistoricConsumptionCo2Water.vue?vue&type=script&lang=ts"

import "./CZHistoricConsumptionCo2Water.vue?vue&type=style&index=0&id=0c5bcee6&scoped=true&lang=css"

import exportComponent from "C:\\Devlop\\C-Zone-v1\\UI_EICPartnership\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5bcee6"]])

export default __exports__